<style scoped>
div {
  /*border: 1px dotted lightgreen;*/
}

td {
  /*border: 1px solid lightgray;*/
}

.lastprice:hover {
  text-decoration: underline;
  cursor: pointer;
}

.sltplabel:hover {
  text-decoration: underline;
  cursor: pointer;
}

@media (min-width: 600px) and (max-width: 1400px) {
  .notebuk {
    font-size: 12px !important;
  }
}

.dispane {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 1000;
  border-radius: 5px;
  background: rgba(42, 47, 68, 0.7);
}

.table-names {
  font-size: 10pt;
  padding-bottom: 8px;
  text-align: right;
  padding-right: 20px;
  color: var(--color-neutral);
}

.err-cell {
  font-size: 12px;
  color: var(--color-danger-light);
  height: 16px;
}
</style>

<template>
  <div>
    <div
      class="box symbbox"
      style="min-width: 448px; position: relative; padding-bottom: 15px;"
    >
      <div
        v-if="$store.state.trade.editTrade"
        class="dispane"
      />
      <ConfirmTradeModal />
      <table style="height: 100%; width: 100%; border-spacing: 0;">
        <tr style="text-align: left; height: 40px;">
          <td style="font-size: 16pt; font-weight: bold; width: 25%; padding-bottom: 8px; padding-right: 5px;">
            <!--            <CoinIcon style="position: relative; top: 3px; margin-right: 5px;" :symbol="symbol" />-->
            <span>{{ symbol }}</span>
          </td>
          <td style="display: flex; justify-content: space-between">
            <RadioGroup
              class="buy-sell-container"
              type="button"
              v-model="$store.state.trade.side"
              @on-change="sideChanged"
              style="flex-shrink: 0"
            >
              <Radio
                label="B"
                style="font-size: 12px; width: 85px; text-align: center;"
              >{{ $text.tr('КУПИТЬ') }}</Radio>
              <Radio
                label="S"
                style="font-size: 12px; width: 85px; text-align: center;"
              >{{ $text.tr('ПРОДАТЬ') }}</Radio>
            </RadioGroup>
            <div
              :class="{'blur-balance': $store.state.sys.hideBalances}"
              style="font-size: 16px; padding-top: 3px; text-align: right;"
              v-if="$store.state.sys.freeBalance !== ''"
            >
              <div>{{ balanceText }}</div>
            </div>
          </td>
        </tr>
        <tr style="text-align: left;">
          <td
            class="table-names"
            style="padding-top: 20px"
          >
            {{ $text.tr('ЦЕНА') }}
          </td>
          <td style="padding-top: 20px">
            <i-input
              :value="$store.state.trade.price"
              size="large"
              :disabled="$store.state.trade.type === 'market'"
              @on-keydown="onkeyDown($event)"
              @on-change="priceChanged"
            >
              <span slot="prepend">
                <div
                  @click="limmarketswitch"
                  style="width: 75px; cursor: pointer; font-size: 13px;"
                >{{ tradeType }}&nbsp;
                  <Icon type="ios-arrow-down" />
                </div>
              </span>
              <span slot="append">
                <div style="width: 50px; font-size: 14px;">{{ $store.state.trade.pair[1] }}</div>
              </span>
            </i-input>
            <div
              v-if="priceError.length > 0"
              class="err-cell"
            >{{ priceError }}</div>
            <div
              v-else
              class="err-cell"
              style="color: var(--color-warning)"
            >{{ priceWarning }}</div>
          </td>
        </tr>
        <tr style="text-align: left;">
          <td
            class="table-names"
            style="padding-bottom: 0px"
          >{{ $text.tr('КОЛ-ВО') }}</td>
          <td style="padding-top: 10px;">
            <i-input
              :value="$store.state.trade.qty"
              size="large"
              @on-keydown="onkeyDown($event)"
              @on-change="qtyChanged"
            ><span slot="append">
                <div style="min-width: 50px;  font-size: 14px;">{{ $store.state.trade.pair[0] }}</div>
              </span>
            </i-input>
            <div class="err-cell">{{ qtyError ? qtyError : sltpError }}</div>
          </td>
        </tr>
        <tr style="text-align: left; font-size: 10pt;">
          <td></td>
          <td style="padding-top: 5px;">
            <span
              class="pctofbalance"
              style="padding-left: 10px;"
              @click="autoamount('0.01')"
            >1%</span>
            <span
              class="pctofbalance"
              style="padding-left: 20px;"
              @click="autoamount('0.05')"
            >5%</span>
            <span
              class="pctofbalance"
              style="padding-left: 20px;"
              @click="autoamount('0.1')"
            >10%</span>
            <span
              class="pctofbalance"
              style="padding-left: 20px;"
              @click="autoamount('0.25')"
            >25%</span>
            <span
              class="pctofbalance"
              style="padding-left: 20px;"
              @click="autoamount('0.5')"
            >50%</span>
            <span
              class="pctofbalance"
              style="padding-left: 20px;"
              @click="autoamount('0.75')"
            >75%</span>
            <span
              class="pctofbalance"
              style="padding-left: 20px;"
              @click="autoamount('1.0')"
            >100%</span>
          </td>
        </tr>
        <tr style="text-align: left;">
          <td class="table-names">{{ $text.tr('СУММА') }}</td>
          <td style="padding-top: 5px;">
            <i-input
              :value="$store.state.trade.amount"
              size="large"
              @on-keydown="onkeyDown($event)"
              @on-change="totChanged"
            ><span slot="append">
                <div style="width: 50px; font-size: 14px;">{{ $store.state.trade.pair[1] }}</div>
              </span>
            </i-input>
            <div class="err-cell">{{ totalError }}</div>
          </td>
        </tr>
        <tr
          v-if="!$store.getters.isFutures"
          class="notebuk"
          style="text-align: left; font-size: 16px;"
        >
          <td></td>
          <td style="padding-top: 5px;">
            <div style="display: flex; justify-content: flex-start;">
              <div style="width: 50%">
                <span style="color:var(--color-danger-light)">Stop Loss: </span><span
                  class="sltplabel"
                  @click="showSltp()"
                >
                  {{ parseFloat($store.state.trade.slprice) > 0 ? parseFloat($store.state.trade.sltrail) > 0 ? $store.state.trade.slprice + ' trail' : $store.state.trade.slprice : $text.tr('нет') }}
                </span>
              </div>
              <div>
                <span style="color: var(--color-success-light)">Take Profit: </span><span
                  class="sltplabel"
                  @click="showSltp()"
                >
                  {{ $store.state.trade.tpprice > 0 ? $store.state.trade.tptrail > 0 ? $store.state.trade.tpprice + ' trail' : $store.state.trade.tpprice : $text.tr('нет') }}
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr
          v-else
          class="notebuk"
          style="text-align: left; font-size: 16px;"
        >
          <td style="text-align: right; padding-top: 0px;">
            <Tooltip
              placement="right"
              max-width="260"
              :delay="500"
            >
              <Icon
                style="margin-top: -3px; margin-right: 5px;"
                type="ios-information-circle-outline"
                color="var(--color-text-dark)"
              />
              <div slot="content">{{ $text.tr('Залог - сумма средств, которыми вы рискуете, используя изолированную маржу. В случае кросс-маржи залогом является весь баланс счета. Внимание: Изменение плеча затронет все выставленные на бирже ордера по данной паре. Сумма залога для каждого ордера будет пересчитана.') }} <a
                  style="color: var(--color-accent-dark)"
                  target="_blank"
                  :href="$text.tr('https://doc.capico.app/v/ru/ex/use/binance')"
                >{{ $text.tr('Подробнее') }}</a></div>
            </Tooltip>
            <span style="padding-right: 20px; font-size: 10pt; color: #cdcdcd;">{{ $text.tr('ЗАЛОГ') }}</span>
          </td>
          <td style="padding-top: 0px;">
            <div style="width:100%; display: flex; justify-content: space-between;">
              <div style="padding-left: 1px; margin-right: 20px;">
                {{ depositBIF }}
              </div>
              <div v-if="$store.getters.isFTXFutures">
                <RadioGroup
                  type="button"
                  size="small"
                  v-model="$store.state.trade.leverage"
                  @on-change="leverageChanged"
                  style="flex-shrink: 0"
                >
                  <Radio
                    :label="1"
                    style="font-size: 12px; width: 50px; text-align: center;"
                  >1X</Radio>
                  <Radio
                    :label="3"
                    style="font-size: 12px; width: 50px; text-align: center;"
                  >3X</Radio>
                  <Radio
                    :label="5"
                    style="font-size: 12px; width: 50px; text-align: center;"
                  >5X</Radio>
                  <Radio
                    :label="10"
                    style="font-size: 12px; width: 50px; text-align: center;"
                  >10X</Radio>
                  <Radio
                    :label="20"
                    style="font-size: 12px; width: 50px; text-align: center;"
                  >20X</Radio>
                  <Radio
                    :label="50"
                    style="font-size: 12px; width: 50px; text-align: center;"
                  >50X</Radio>
                </RadioGroup>
              </div>
              <div
                v-else
                style="display: flex; align-items: center; flex-basis: 80%;"
              >
                <Slider
                  v-model="$store.state.trade.leverage"
                  @on-change="leverageChanged"
                  :min="1"
                  :max="50"
                  :step="1"
                  show-tip="never"
                  style="height: 10px; margin-top: -28px; margin-right: 5px; width: 75%"
                >
                </Slider>
                <div style="font-weight: bold; width: 50px; text-align: right;">
                  {{ $store.state.trade.leverage }}X
                </div>
                <div style="min-width: 130px; width: 190px; text-align: right;">
                  <!--                  <Button size="small" style="width: 70px">{{ $store.state.trade.marginType.toUpperCase() }}</Button>-->
                  <RadioGroup
                    type="button"
                    size="small"
                    v-model="$store.state.trade.marginType"
                    @on-change="marginTypeChanged"
                  >
                    <Radio
                      label="cross"
                      :title="$text.tr('Риск всем депозитом')"
                      style="font-size: 10px; width: 55px; text-align: center;"
                    >CROSS</Radio>
                    <Radio
                      label="isolated"
                      :title="$text.tr('Риск только залогом')"
                      style="font-size: 10px; width: 65px; text-align: center;"
                    >ISOLATED</Radio>
                  </RadioGroup>
                </div>
              </div>
              <!--              <div>-->
              <!--                <span style="color:var(--color-danger-light)">Stop Loss: </span><span class="sltplabel" @click="showSltp()">-->
              <!--          {{ parseFloat($store.state.trade.slprice) > 0 ? parseFloat($store.state.trade.sltrail) > 0 ? $store.state.trade.slprice + ' trail' : $store.state.trade.slprice : "нет" }}-->
              <!--        </span>-->
              <!--              </div>-->
              <!--              <div>-->
              <!--                <span style="color: var(--color-success-light)">Take Profit: </span><span class="sltplabel" @click="showSltp()">-->
              <!--          {{ $store.state.trade.tpprice > 0 ? $store.state.trade.tptrail > 0 ? $store.state.trade.tpprice + ' trail' : $store.state.trade.tpprice : "нет" }}-->
              <!--        </span>-->
              <!--              </div>-->
            </div>
          </td>
        </tr>
        <tr style="text-align: center;">
          <td
            colspan="2"
            style="padding-top: 15px; font-size: 12px"
          >
            <Button
              @click="trade()"
              size="large"
              long
              style="width: 100%;"
              :disabled="$store.state.trade.qty === '0' || priceError!=='' || qtyError!=='' || totalError!=='' || sltpError != ''"
            >{{ $store.state.trade.side === 'B' ? $text.tr('КУПИТЬ') : $text.tr('ПРОДАТЬ') }} {{ $store.state.trade.pair[0] }}
              {{ $store.state.trade.type === 'market' ? $text.tr('ПО РЫНКУ') : '' }}</Button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Decimal from 'decimal.js'
import terminal from '@/services/terminal'
import ConfirmTradeModal from './ConfirmTradeModal'
import Api from '@/util/api'

export default {
  name: 'Terminal',
  components: {
    ConfirmTradeModal
  },
  data: function () {
    return {
      qtyError: '',
      priceError: '',
      priceWarning: '',
      totalError: '',
      sltpError: '',
      balanceText: '',
      qtyFocused: false,
      isExchChanged: false
    }
  },
  watch: {
    '$store.state.sys.tradeExchange.Id': function (exchId) {
      this.symbolChanged(this.$store.state.trade.symbol)
      this.isExchChanged = true
    },
    '$store.state.trade.side': function (side) {
      if (this.$store.getters.isOKXFutures || this.$store.getters.isBYF) {
        this.symbolChanged(this.$store.state.trade.symbol)
      }
    },
    '$store.state.trade.symbol': function (symbol) {
      if (this.isExchChanged) {
        this.isExchChanged = false
        return
      }

      this.symbolChanged(symbol)
    },
    '$store.state.sltpModal': function (showModal) {
      if (!showModal) {
        this.checkErrors()
      }
    },
    '$store.state.trade.price': function () {
      if (!this.$store.state.trade.price) {
        return
      }
      if (this.qtyFocused) {
        this.$store.state.trade.amount = terminal
          .returnDecimalValue(this.$store.state.trade.qty)
          .mul(this.$store.state.trade.price)
          .toDP(8)
          .toString()
      } else {
        if (
          !terminal.returnDecimalValue(this.$store.state.trade.price).equals(0)
        ) {
          const filter = this.symbolsFilter[this.$store.state.trade.symbol]
          let qtyDec = 8
          if (filter) {
            qtyDec = filter.QtyDec
          }
          this.$store.state.trade.qty = terminal
            .returnDecimalValue(this.$store.state.trade.amount)
            .dividedBy(this.$store.state.trade.price)
            .toDP(qtyDec, Decimal.ROUND_DOWN)
            .toString()
        }
      }
      this.checkErrors()
    },
    '$store.state.sys.lastTrade': function () {
      this.$store.dispatch('updateAssetBalance', true)
    },
    '$store.state.sys.tradeExchange': function (newExch) {
      this.balanceText = ''
    },
    '$store.state.sys.freeBalance': function () {
      this.balanceText = this.returnBalanceText()
    },
    '$store.state.trade.leverage': function (leverage) {
      localStorage.setItem('capico_app_leverage', JSON.stringify(leverage))
      this.checkErrors()
    }
  },
  created () {
    this.applyOKXMarginType()
  },
  mounted () {
    Decimal.set({ toExpNeg: -10 })
    this.$store.dispatch('updateAssetBalance')
    this.symbolChanged(this.$store.state.trade.symbol)
  },
  computed: {
    symbolsFilter () {
      return this.$store.state.data.symbolsfilter
    },
    symbol () {
      if (
        this.$store.getters.isFTXFutures ||
        this.$store.getters.isOKXFutures
      ) {
        return this.$store.state.trade.pair[0]
      }
      return (
        this.$store.state.trade.pair[0] + '/' + this.$store.state.trade.pair[1]
      )
    },
    depositBIF () {
      return (
        '$' +
        terminal
          .returnDecimalValue(this.$store.state.trade.amount)
          .div(this.$store.state.trade.leverage)
          .toDP(2)
          .toString()
      )
    },
    tradeType () {
      switch (this.$store.state.trade.type) {
        case 'limit':
          return this.$text.tr('Лимитный')
        case 'market':
          return this.$text.tr('По рынку')
        case 'cond':
          return this.$text.tr('Отлож.')
      }
      return this.$store.state.trade.type === 'limit'
        ? this.$text.tr('Лимитный')
        : this.$text.tr('По рынку')
    }
  },
  methods: {
    applyOKXMarginType () {
      if (!this.$store.getters.isOKXFutures) {
        return
      }

      const marginType = localStorage.getItem('okx_marginType')
      this.$store.state.trade.marginType = marginType || 'isolated'
    },
    symbolChanged (symbol) {
      if (!this.$store.getters.isFutures) {
        return
      }

      this.applyOKXMarginType()
      terminal.getMargin({ symbol }).then(response => {
        if (!response.data || response.data.err) {
          return
        }

        console.log(response.data)
        this.$store.state.trade.marginType = response.data.MarginType
        this.$store.state.trade.leverage = response.data.Leverage
      })
    },
    leverageChanged (leverage) {
      if (!this.$store.getters.isFutures) {
        return
      }

      terminal
        .setMargin({ leverage, src: 'l' })
        .then(response => {
          if (!response.data) {
            return
          }

          if (response.data.err) {
            this.symbolChanged(this.$store.state.trade.symbol)
            return
          }

          this.$Notice.success({
            title: this.$text.tr('Плечо установлено: ') + leverage + 'X',
            duration: 3
          })
          this.$store.dispatch('updateTrades')
          setTimeout(() => {
            this.$store.dispatch('updateAssets')
            this.$store.dispatch('updateAssetBalance', true)
          }, 500)
        })
        .catch(() => {
          this.symbolChanged(this.$store.state.trade.symbol)
        })
    },
    marginTypeChanged (marginType) {
      if (
        this.$store.state.sys.tradeExchange.ExchId !== 'BIF' &&
        this.$store.state.sys.tradeExchange.ExchId !== 'OKX' &&
        !this.$store.getters.isBYF
      ) {
        return
      }

      if (this.$store.state.sys.tradeExchange.ExchId === 'OKX') {
        localStorage.setItem('okx_marginType', marginType)
      }

      terminal.setMargin({ marginType, src: 'm' }).then(response => {
        if (!response.data) {
          return
        }

        if (response.data.err) {
          this.symbolChanged(this.$store.state.trade.symbol)
          return
        }

        this.$Notice.success({
          title:
            this.$text.tr('Тип маржи установлен: ') + marginType.toUpperCase(),
          duration: 3
        })
      })
    },
    returnBalanceText () {
      let freeBalance = ''
      let asset = ''
      if (this.$store.getters.isFutures) {
        freeBalance = this.$store.state.sys.freeBalance
        asset = this.$store.state.trade.pair[1]
      } else {
        if (this.$store.state.trade.side === 'B') {
          freeBalance = this.$store.state.sys.freeBalance
          asset = this.$store.state.trade.pair[1]
        } else {
          freeBalance = this.$store.state.sys.freeBalance2
          asset = this.$store.state.trade.pair[0]
        }
      }
      return freeBalance + ' ' + asset
    },
    showSltp () {
      this.$store.state.sltpIndex = -1
      this.$store.state.sltpTrade = true
      this.$store.state.sltpModal = true
    },
    selectPrice (price) {
      this.$store.state.trade.price = new Decimal(price).toDP(8).toString()
    },
    trade () {
      if (this.$store.state.sys.isNoConfirmationMode) {
        terminal.ApiCreateTrade(this)
      } else {
        this.$store.state.confirmModal.show = true
      }
    },
    numAfterDot (numb) {
      if (typeof numb === 'number') {
        numb = numb.toString()
      }
      // console.log(numb)
      // console.log(typeof numb)
      if (!numb.includes('.')) {
        return 0
      } else {
        return numb.split('.')[1].length
      }
    },
    checkErrors () {
      if (this.$store.state.trade.qty === '') {
        return
      }
      if (this.$store.state.trade.price === '') {
        return
      }
      const filt = this.symbolsFilter[this.$store.state.trade.symbol]
      if (!filt) {
        return
        // console.log('wrong filter: ' + this.$store.state.trade.symbol)
        // console.log(this.symbolsFilter)
      }
      const bal1 =
        this.$store.state.trade.side === 'B' || this.$store.getters.isFutures
          ? this.$store.state.sys.freeBalance === ''
            ? '0'
            : this.$store.state.sys.freeBalance
          : this.$store.state.sys.freeBalance2

      if (
        !this.$store.getters.isFutures &&
        this.$store.state.trade.side === 'S' &&
        parseFloat(this.$store.state.trade.qty) > parseFloat(bal1)
      ) {
        this.qtyError = this.$text.tr('Недостаточно средств')
      } else if (
        new Decimal(this.$store.state.trade.qty).lessThan(filt.QtyMin)
      ) {
        this.qtyError = this.$text.tr('Минимальное кол-во: ') + filt.QtyMin
      } else if (this.numAfterDot(this.$store.state.trade.qty) > filt.QtyDec) {
        this.qtyError =
          this.$text.tr('Максимальное число знаков после запятой: ') +
          filt.QtyDec
      } else {
        this.qtyError = ''
      }

      if (
        !this.$store.getters.isFutures &&
        this.$store.state.trade.side === 'B' &&
        parseFloat(this.$store.state.trade.amount) > parseFloat(bal1)
      ) {
        this.totalError = this.$text.tr('Недостаточно средств')
      } else if (
        terminal
          .returnDecimalValue(this.$store.state.trade.amount)
          .lessThan(filt.AmountMin)
      ) {
        this.totalError = this.$text.tr('Минимальная сумма: ') + filt.AmountMin
      } else {
        this.totalError = ''
      }

      if (
        this.$store.state.trade.type === 'cond' &&
        this.$store.state.trade.side === 'B' &&
        new Decimal(this.$store.state.trade.price).lessThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        // this.priceError = 'Цена должна быть выше рыночной'
      } else if (
        this.$store.state.trade.type === 'cond' &&
        this.$store.state.trade.side === 'S' &&
        new Decimal(this.$store.state.trade.price).greaterThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        // this.priceError = 'Цена должна быть ниже рыночной'
      } else if (
        this.numAfterDot(this.$store.state.trade.price) > filt.PriceDec
      ) {
        this.priceError =
          this.$text.tr('Максимальное число знаков после запятой: ') +
          filt.PriceDec
        return
      } else {
        this.priceError = ''
      }

      if (
        this.$store.state.sys.tradeExchange.ExchId === 'BIF' &&
        this.$store.state.trade.type === 'limit' &&
        this.$store.state.trade.side === 'B' &&
        new Decimal(this.$store.state.trade.price).greaterThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        this.priceError = this.$text.tr('Цена должна быть ниже рыночной')
      } else if (
        this.$store.state.sys.tradeExchange.ExchId === 'BIF' &&
        this.$store.state.trade.type === 'limit' &&
        this.$store.state.trade.side === 'S' &&
        new Decimal(this.$store.state.trade.price).lessThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        this.priceError = this.$text.tr('Цена должна быть выше рыночной')
      }

      if (
        this.$store.getters.isBYF &&
        this.$store.state.trade.type === 'limit' &&
        filt.PriceMin.last !== 1
      ) {
        if (!new Decimal(this.$store.state.trade.price).div(filt.PriceMin).isInt()) {
          this.priceError = this.$text.tr('Цена должна быть кратна ' + filt.PriceMin)
        }
      }

      if (
        this.$store.state.trade.type === 'cond' &&
        new Decimal(this.$store.state.trade.price).lessThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        this.priceWarning =
          this.$text.tr('Будет исполнен, когда цена будет ≤ ') +
          this.$store.state.trade.price
        this.$store.state.trade.direction = 'B'
      } else if (
        this.$store.state.trade.type === 'cond' &&
        new Decimal(this.$store.state.trade.price).greaterThanOrEqualTo(
          this.$store.state.sys.lastPrice
        )
      ) {
        this.priceWarning =
          this.$text.tr('Будет исполнен, когда цена будет ≥ ') +
          this.$store.state.trade.price
        this.$store.state.trade.direction = 'A'
      } else {
        this.priceWarning = ''
      }

      if (this.$store.getters.isFutures) {
        if (!this.$store.state.trade.leverage) {
          console.log('checkErrors: no leverage')
          return
        }
        const deposit = terminal
          .returnDecimalValue(this.$store.state.trade.amount)
          .div(this.$store.state.trade.leverage)
          .toDP(2)
        if (deposit.greaterThan(bal1)) {
          this.totalError = this.$text.tr('Недостаточно средств')
        }
      }
      this.checkSltpErrors()
    },
    checkSltpErrors () {
      const filt = this.symbolsFilter[this.$store.state.trade.symbol]
      const amountMin = new Decimal(1.05).mul(filt.AmountMin).toString()
      let minsum = new Decimal(10000)
      this.$store.state.trade.tpsteps.forEach(step => {
        const sum = new Decimal(step.Qty).mul(step.Price)
        if (sum.lessThan(minsum)) {
          minsum = sum
        }
      })
      if (
        this.$store.state.trade.side === 'B' &&
        this.$store.state.trade.slprice &&
        new Decimal(this.$store.state.trade.slprice)
          .mul(this.$store.state.trade.qty)
          .lessThan(amountMin)
      ) {
        this.sltpError =
          'Ошибка в Stop Loss. Кол-во должо быть больше ' +
          new Decimal(amountMin)
            .div(this.$store.state.trade.slprice)
            .toDP(filt.QtyDec, Decimal.ROUND_DOWN)
            .toString()
      } else if (
        this.$store.state.trade.side === 'S' &&
        this.$store.state.trade.tpprice &&
        new Decimal(this.$store.state.trade.tpprice)
          .mul(this.$store.state.trade.qty)
          .lessThan(amountMin)
      ) {
        this.sltpError =
          'Ошибка в Take Profit. Кол-во должо быть больше ' +
          new Decimal(amountMin)
            .div(this.$store.state.trade.tpprice)
            .toDP(filt.QtyDec, Decimal.ROUND_DOWN)
            .toString()
      } else if (minsum.lessThan(amountMin)) {
        if (!minsum.toNumber()) {
          return
        }

        const x = new Decimal(amountMin)
          .mul(this.$store.state.trade.qty)
          .div(minsum)
        this.sltpError =
          'Ошибка в лесенке. Кол-во должно быть больше ' +
          x.toDP(filt.QtyDec, Decimal.ROUND_DOWN).toString()
      } else {
        this.sltpError = ''
      }
    },
    priceChanged (e) {
      if (e.target) {
        this.$store.state.trade.price = e.target.value
          .replace('ю', '.')
          .replace(/[^\d.-]/g, '')
      }
      if (
        this.$store.state.trade.price.charAt(0) === '0' &&
        this.$store.state.trade.price.charAt(1) !== '.'
      ) {
        this.$store.state.trade.price = this.$store.state.trade.price.substring(
          1
        )
      }
      if (
        !terminal.returnDecimalValue(this.$store.state.trade.price).equals(0)
      ) {
        const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
        this.$store.state.trade.qty = terminal
          .returnDecimalValue(this.$store.state.trade.amount)
          .dividedBy(this.$store.state.trade.price)
          .toDP(qtyDec, Decimal.ROUND_DOWN)
          .toString()
      }
      this.checkErrors()
    },
    totChanged (e) {
      this.qtyFocused = false
      this.$store.state.trade.amount = e.target.value
        .replace('ю', '.')
        .replace(/[^\d.-]/g, '')
      if (
        this.$store.state.trade.amount.charAt(0) === '0' &&
        this.$store.state.trade.amount.charAt(1) !== '.'
      ) {
        this.$store.state.trade.amount = this.$store.state.trade.amount.substring(
          1
        )
      }
      if (
        this.$store.state.trade.amount === '' ||
        this.$store.state.trade.amount === '0'
      ) {
        this.$store.state.trade.qty = '0'
      } else if (
        !terminal.returnDecimalValue(this.$store.state.trade.price).equals(0)
      ) {
        const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
        this.$store.state.trade.qty = new Decimal(
          this.$store.state.trade.amount
        )
          .dividedBy(this.$store.state.trade.price)
          .toDP(qtyDec, Decimal.ROUND_DOWN)
          .toString()
      }
      this.recalculateSteps()
      this.checkErrors()
    },
    qtyChanged (e) {
      this.qtyFocused = true
      this.$store.state.trade.qty = e.target.value
        .replace('ю', '.')
        .replace(/[^\d.-]/g, '')
      if (
        this.$store.state.trade.qty.charAt(0) === '0' &&
        this.$store.state.trade.qty.charAt(1) !== '.'
      ) {
        this.$store.state.trade.qty = this.$store.state.trade.qty.substring(1)
      }
      if (
        this.$store.state.trade.qty === '' ||
        this.$store.state.trade.qty === '0'
      ) {
        this.$store.state.trade.amount = '0'
      } else {
        this.$store.state.trade.amount = terminal
          .returnDecimalValue(this.$store.state.trade.qty)
          .mul(this.$store.state.trade.price)
          .toDP(8)
          .toString()
      }
      this.recalculateSteps()
      this.checkErrors()
    },
    recalculateSteps () {
      const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
      let qtySum = new Decimal(0)
      this.$store.state.trade.tpsteps.forEach((step, index) => {
        if (index < this.$store.state.trade.tpsteps.length - 1) {
          step.Qty = new Decimal(this.$store.state.trade.qty)
            .mul(step.Pct)
            .mul('0.01')
            .toDP(qtyDec, Decimal.ROUND_DOWN)
            .toString()
          qtySum = qtySum.add(step.Qty)
        } else {
          step.Qty = new Decimal(this.$store.state.trade.qty)
            .sub(qtySum)
            .toDP(qtyDec, Decimal.ROUND_DOWN)
            .toString()
        }
      })
    },
    sideChanged () {
      this.$store.dispatch('cleanSltp')
      this.balanceText = this.returnBalanceText()
      this.checkErrors()
    },
    onkeyDown (e) {
      if (
        [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return
      }

      if (!e.target.value.includes('.')) {
        if (e.key === ',' || e.key === 'ю') {
          // change ',' to '.'
          setTimeout(function () {
            e.target.value += '.'
          }, 4)
          e.preventDefault()
        } else if (e.key === '.') {
          // let '.' happen
          return
        }
      }

      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault()
      }
    },
    autoamount (pct) {
      let bal1 = this.$store.state.sys.freeBalance

      if (
        !this.$store.getters.isFutures &&
        this.$store.state.trade.side === 'S'
      ) {
        bal1 = this.$store.state.sys.freeBalance2
      }

      const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
      if (this.$store.getters.isFutures) {
        const total1 = new Decimal(bal1)
          .times(pct)
          .mul(this.$store.state.trade.leverage)
          .toDP(8)
        this.$store.state.trade.qty = total1
          .dividedBy(this.$store.state.trade.price)
          .toDP(qtyDec, Decimal.ROUND_DOWN)
          .toString()
        this.$store.state.trade.amount = new Decimal(
          this.$store.state.trade.qty
        )
          .mul(this.$store.state.trade.price)
          .toDP(8)
          .toString()
      } else if (this.$store.state.trade.side === 'B') {
        const total = new Decimal(bal1).times(pct).toDP(8)
        this.$store.state.trade.qty = total
          .dividedBy(this.$store.state.trade.price)
          .toDP(qtyDec, Decimal.ROUND_DOWN)
          .toString()
        this.$store.state.trade.amount = new Decimal(
          this.$store.state.trade.qty
        )
          .mul(this.$store.state.trade.price)
          .toDP(8)
          .toString()
      } else {
        this.$store.state.trade.qty = Decimal(bal1)
          .times(pct)
          .toDP(qtyDec, Decimal.ROUND_DOWN)
          .toString()
        this.$store.state.trade.amount = new Decimal(
          this.$store.state.trade.qty
        )
          .mul(this.$store.state.trade.price)
          .toDP(8)
          .toString()
      }
      this.recalculateSteps()
      this.checkErrors()
    },
    limmarketswitch () {
      if (this.$store.state.trade.type === 'limit') {
        this.$store.state.trade.type = 'market'
      } else if (this.$store.state.trade.type === 'market') {
        this.$store.state.trade.type = 'cond'
      } else {
        this.$store.state.trade.type = 'limit'
      }
      localStorage.setItem(
        'capico_app_trade_type',
        this.$store.state.trade.type
      )
      this.checkErrors()
    }
  }
}
</script>
